import React from 'react';
import { Spinner } from 'react-bootstrap';

import OfferCard from './OfferCard';

function OffersSection({ offers, loadingMore = false }) {
  const validOffers = (offers || []).filter((offer) => offer?.status === 'ok');
  const extraOffers = validOffers.slice(1);

  const titleClass = 'fw-bold mb-1'
  const titleStyle = { fontSize: '1.5rem', color: 'var(--color-heading)' };

  return (
    <>
      {validOffers.length > 0 && (
        <>
        <section>
          <p className={titleClass} style={titleStyle}>
            Mejor opción
          </p>
          <OfferCard
            offer={validOffers[0]}
            isBest
          />
        </section>

        <section>
          <p className={titleClass} style={titleStyle}>
            Más opciones
          </p>
          {extraOffers.length > 0 && 
            extraOffers.map((offer) => (
              <OfferCard
                key={offer._id}
                offer={offer}
              />
            ))
          }
          {extraOffers.length === 0 && !loadingMore && (
            <div className="bg-white rounded-3 p-3 border-2 border-light shadow-sm">
              <p className="mb-0 text-muted">No tenemos más alternativas.</p>
            </div>
          )}
        </section>
      </>
      )}

      {!validOffers.length && (
        <section>
          <p className={titleClass} style={titleStyle}>
            Ofertas
          </p>
          <div className="bg-white rounded-3 p-3 border-2 border-light shadow-sm">
            <p className="mb-0 text-muted">
              Aún no tenemos ofertas disponibles para esta solicitud.
            </p>
          </div>
        </section>
      )}

      {loadingMore && (
        <div className="d-flex align-items-center gap-2 text-muted mt-4">
          <Spinner animation="border" role="status" size="sm" />
          <small>Cargando más ofertas...</small>
        </div>
      )}
    </>
  );
}

export default OffersSection;
